import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SettingsIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Settings",
    children: /*#__PURE__*/_jsx("path", {
      d: "M27.88 13.38h-2.55c-.21-.79-.49-1.47-.84-2.12l.02.05 1.8-1.8c.4-.38.65-.93.65-1.52s-.24-1.14-.65-1.52l-.73-.77c-.38-.39-.93-.65-1.52-.65s-1.14.24-1.52.65l-1.83 1.8c-.57-.32-1.23-.6-1.93-.8l-.06-.02V4.12c0-1.17-.96-2.13-2.13-2.13h-1.06c-1.18 0-2.13.96-2.13 2.13v2.55c-.79.21-1.48.49-2.13.84l.05-.02-1.8-1.8c-.38-.4-.94-.66-1.54-.66s-1.16.26-1.54.66l-.73.73c-.4.38-.65.93-.65 1.52s.24 1.14.65 1.52l1.8 1.83c-.32.57-.6 1.23-.8 1.93l-.02.06H4.15c-1.17 0-2.13.96-2.13 2.13v1.14c0 1.18.95 2.13 2.13 2.13H6.7c.21.76.49 1.41.83 2.04l-.02-.05-1.8 1.8c-.4.38-.65.93-.65 1.52s.24 1.14.65 1.52l.77.77c.38.4.93.65 1.52.65s1.14-.24 1.52-.65l1.8-1.79c.56.32 1.23.6 1.93.8l.06.02v2.55c0 1.17.96 2.13 2.13 2.13h1.06c1.17 0 2.13-.96 2.13-2.13v-2.55a9.7 9.7 0 0 0 2.13-.84l-.05.02 1.8 1.8c.38.4.93.65 1.52.65s1.14-.24 1.52-.65l.77-.77c.4-.38.65-.93.65-1.53s-.24-1.14-.65-1.52l-1.8-1.81c.32-.57.6-1.23.8-1.93l.02-.06h2.55c1.17 0 2.13-.96 2.13-2.13v-1.06c0-1.18-.96-2.13-2.13-2.13v.02Zm-5.41 3.17a6.7 6.7 0 0 1-.38 1.72c-.05.15-.12.29-.18.44a6.56 6.56 0 0 1-3.15 3.17l-.04.02-.45.18c-.5.19-1.09.33-1.69.38h-1.11a6.7 6.7 0 0 1-1.72-.38l-.44-.18a6.56 6.56 0 0 1-3.17-3.15l-.02-.04c-.06-.15-.13-.3-.18-.45-.19-.5-.33-1.09-.38-1.69v-1.11c.03-.39.1-.76.18-1.11.06-.26.14-.46.21-.66v.04c.04-.15.11-.3.17-.45a6.56 6.56 0 0 1 3.15-3.17l.04-.02.45-.18c.5-.19 1.09-.33 1.69-.38h1.11c.62.05 1.19.19 1.72.38l.44.18c1.41.66 2.53 1.78 3.17 3.15l.02.04c.06.15.13.3.18.45.19.5.33 1.09.38 1.69v1.11Zm-6.46-4.72c-2.31 0-4.18 1.87-4.18 4.18s1.87 4.18 4.18 4.18 4.18-1.87 4.18-4.18-1.87-4.18-4.18-4.18"
    })
  }));
};